import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const EditVehicle = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [vehicle, setVehicle] = useState([])
  const [transporters, setTransporters] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-vehicle/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const vehResp = await api.get("vehicle/" + id)
    const transResp = await api.get("transporters")
    setVehicle(vehResp.data.data[0])
    setTransporters(Array.isArray(transResp.data.data) ? transResp.data.data : transResp.data.data?.data || [])
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Vehicle</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/vehicles" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="transporter"
                    label="Transporter"
                    required
                    value={vehicle.transporter}
                  >
                    <option value="">Select Transporter</option>
                    {transporters.map((transporter, i) => (
                      <option key={i} value={transporter.id}>
                        {transporter.transporterName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="vehicleNumber"
                    label="Vehicle Registration Number "
                    value={vehicle.vehicleNumber}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="driverName"
                    label="Driver Name"
                    value={vehicle.driverName}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="driverMobile"
                    label="Driver Mobile"
                    value={vehicle.driverMobile}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Vehicle is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Vehicle </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditVehicle
